// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-page {
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;
}

.notifications-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.mark-all-read-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.mark-all-read-btn:hover {
  background-color: #2980b9;
}

.mark-all-read-btn:disabled {
  background-color: #bdc3c7;
  cursor: default;
}

.notifications-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  align-items: center;
}

.filter-group label {
  margin-right: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #555;
}

.filter-group select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 0.9rem;
  color: #333;
  min-width: 120px;
}

.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.notification-item {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.notification-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.notification-item.unread {
  border-left: 4px solid #3498db;
}

.notification-item.read {
  border-left: 4px solid #bdc3c7;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eaeaea;
}

.notification-type {
  font-weight: 600;
  font-size: 0.9rem;
  color: #3498db;
}

.notification-date {
  font-size: 0.8rem;
  color: #7f8c8d;
}

.notification-body {
  padding: 16px;
  font-size: 0.95rem;
  color: #333;
  line-height: 1.5;
}

.notification-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-top: 1px solid #eaeaea;
}

.view-staff-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.2s;
  text-align: center;
}

.view-staff-btn:hover {
  background-color: #2980b9;
}

.mark-read-btn {
  background-color: transparent;
  color: #3498db;
  border: 1px solid #3498db;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.2s;
}

.mark-read-btn:hover {
  background-color: rgba(52, 152, 219, 0.1);
}

.notifications-loading,
.notifications-error {
  text-align: center;
  padding: 40px;
  font-size: 1rem;
}

.notifications-error {
  color: #e74c3c;
}

@media (max-width: 768px) {
  .notifications-page {
    padding: 16px;
  }
  
  .notifications-filters {
    flex-direction: column;
    gap: 12px;
  }
  
  .filter-group {
    width: 100%;
  }
  
  .filter-group select {
    width: 100%;
  }
  
  .notification-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .notification-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .view-staff-btn,
  .mark-read-btn {
    width: 100%;
    text-align: center;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/NotificationsPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".notifications-page {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.notifications-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.notifications-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.mark-all-read-btn {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.mark-all-read-btn:hover {\n  background-color: #2980b9;\n}\n\n.mark-all-read-btn:disabled {\n  background-color: #bdc3c7;\n  cursor: default;\n}\n\n.notifications-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n}\n\n.filter-group label {\n  margin-right: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #555;\n}\n\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 0.9rem;\n  color: #333;\n  min-width: 120px;\n}\n\n.notifications-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.notification-item {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.notification-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.notification-item.unread {\n  border-left: 4px solid #3498db;\n}\n\n.notification-item.read {\n  border-left: 4px solid #bdc3c7;\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.notification-type {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #3498db;\n}\n\n.notification-date {\n  font-size: 0.8rem;\n  color: #7f8c8d;\n}\n\n.notification-body {\n  padding: 16px;\n  font-size: 0.95rem;\n  color: #333;\n  line-height: 1.5;\n}\n\n.notification-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #eaeaea;\n}\n\n.view-staff-btn {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background-color 0.2s;\n  text-align: center;\n}\n\n.view-staff-btn:hover {\n  background-color: #2980b9;\n}\n\n.mark-read-btn {\n  background-color: transparent;\n  color: #3498db;\n  border: 1px solid #3498db;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background-color 0.2s;\n}\n\n.mark-read-btn:hover {\n  background-color: rgba(52, 152, 219, 0.1);\n}\n\n.notifications-loading,\n.notifications-error {\n  text-align: center;\n  padding: 40px;\n  font-size: 1rem;\n}\n\n.notifications-error {\n  color: #e74c3c;\n}\n\n@media (max-width: 768px) {\n  .notifications-page {\n    padding: 16px;\n  }\n  \n  .notifications-filters {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .filter-group {\n    width: 100%;\n  }\n  \n  .filter-group select {\n    width: 100%;\n  }\n  \n  .notification-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .notification-actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .view-staff-btn,\n  .mark-read-btn {\n    width: 100%;\n    text-align: center;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
